export class AboHandeling {
  static aboValid(abo?: string, abo_status?: string, abo_end?: Date): boolean {
    let res = abo != undefined && abo != "no";
    if (abo_status == "cancelled" && abo_end && abo_end < new Date()) {
      return false;
    }

    if (abo_status == "non_renewing") {
    }
    // subscription.status == "in_trial" ||
    // subscription.status == "active" ||
    // subscription.status == "cancelled"||
    // subscription.status=="non_renewing"
    if (abo_status != "active" && abo_status != "in_trial" && abo_end && abo_end < new Date()) {
      return false;
    }
    return res;
  }
  static aboInfo(abo?: string): { onlyOneProject: boolean } {
    const res = { onlyOneProject: true };
    if (abo) {
    }
    return res;
  }
}
